import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import COLORS from '@mlb/react-patterns/style/universal.color';
import IconPattern from '@mlb/react-patterns/components/Icon/icon';
import Card from './ModalCard';
import Instructions from './Instructions';

import { useDictionary } from 'bdvp-common/src/hooks/config';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const Header = styled.header`
    padding: 18px;
    text-align: center;
`;

const Placeholder = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const Message = styled.p`
    max-width: 80%;
    padding: 18px;
    text-align: center;
    font-size: 15px;
    color: ${COLORS.mlbGrey2};
`;

const Icon = styled(IconPattern)`
    stroke: none;
`;

const List = styled.ol`
    padding: ${({ theme }) => `20px ${theme.pageTemplate.paddingLeftRight.xs}`};
`;

const ListItem = styled(motion.li)`
    margin-bottom: 20px;
    background-color: ${COLORS.mlbGrey7};
`;

const CardOverride = styled(Card).attrs(({ theme }) => ({
    imgSizes: `calc((100vw - ${parseFloat(theme.pageTemplate.paddingLeftRight.xs) * 2 + 10}px) / 2)`,
}))``;

const Content = (props) => {

    const {
        clipsData,
        clipsLoading,
        reel,
        removeClip,
        reorder,
        openClipTrimming,
    } = props;

    const {
        create_reel_empty_msg: createReelEmptyMsg = 'To get started, add one or more highlights to your custom reel.',
    } = useDictionary();

    const isEmpty = !reel?.reelClips?.length;
    const cards = clipsData.map((item, index, list) => (
        <ListItem
            key={item.id}
            positionTransition={{
                type: 'spring',
                damping: 20,
                stiffness: 100,
                mass: 0.5,
            }}
        >
            <CardOverride
                index={index}
                numberOfCards={list.length}
                mediaPlayback={item}
                clipsLoading={clipsLoading}
                removeClip={removeClip}
                reorder={reorder}
                openClipTrimming={openClipTrimming}
                reel={reel}
            />
        </ListItem>
    ));

    return (
        <Container>
            <Header>
                <Instructions isEmpty={isEmpty} />
            </Header>

            {isEmpty
                ? (
                    <Placeholder>
                        <Icon name={'reels'} width={96} fill={COLORS.mlbGray6} />
                        <Message>{createReelEmptyMsg}</Message>
                    </Placeholder>
                )
                : (
                    <List>
                        {cards}
                    </List>
                )
            }

        </Container>
    );

};

Content.propTypes = {
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    clipsData: PropTypes.array.isRequired,
    clipsLoading: PropTypes.bool.isRequired,
    reel: PropTypes.object.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
};

export default Content;
